import * as THREE from "three";
import React, { useState, useRef, useEffect, memo } from 'react';
import { useFrame, useThree } from "@react-three/fiber";
import Control from '../store/control';
import { ToCoord3D } from "../shape/Intersect";
import { STLExporter } from 'three/addons/exporters/STLExporter.js';
import { laplacianSmooth } from '../shape/utils/geometry';

function save( blob, filename ) {
  const link = document.createElement( 'a' );
  link.style.display = 'none';
  document.body.appendChild( link );
  
  link.href = URL.createObjectURL( blob );
  link.download = filename;
  link.click();
}

function saveArrayBuffer( buffer, filename ) {
  save( new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename );
}

const handleExport = (outputGeom) => {
  console.log(outputGeom)
  if (outputGeom == null) {
    toast.error('No mesh to export.')
    return;
  }
  const scene = new THREE.Scene();
  const saveGeom = outputGeom.clone();
  const material = new THREE.MeshStandardMaterial( { color: 0x000000 } );
  saveGeom.rotateX(Math.PI/2);
  let mesh = new THREE.Mesh(saveGeom, material);

  scene.add(mesh.clone());

  const exporter = new STLExporter();
  const result = exporter.parse( scene, { binary: true } );

  saveArrayBuffer( result, 'socket.stl' );
}

const MSocket = memo(({meshSocket, clickable, opacity, executeSmooth, iterationSmooth, color, colorSub, colorHigh}) => {
  console.log("msocket");
  const ref = useRef();
  const refMesh = useRef();
  const setControl = Control.Get('setControl');
  const { camera, mouse } = useThree();
  const [executeSmoothControl, setExecuteSmoothControl] = useState(false);

  var rotation = [];
  if (process.env.REACT_APP_CALC_MODE == 0) {
    rotation = [0, 0, 0];
  } else if (process.env.REACT_APP_CALC_MODE == 1) {
    rotation = [-Math.PI/2, 0, 0];
  }

  const onClick = () => {
    console.log('click')
    if (clickable) {
      var pt = ToCoord3D(meshSocket, camera, mouse);
      if(pt){
        console.log('Socket click (' + mouse.x.toFixed(2) + ", " + mouse.y.toFixed(2) + ") --> ("+ pt.x.toFixed(2) + ", " + pt.y.toFixed(2) + ", " + pt.z.toFixed(2) + ")");
        setControl(s => {s.click = pt});
      }
    }
  };

  // https://qiita.com/baikichiz/items/11e0079bf4cf48003a8b
  useEffect(() => {
    if (meshSocket) {
      if (process.env.REACT_APP_CALC_MODE == 0) {
        refMesh.current.geometry = meshSocket.geometry;
        if (meshSocket.geometry.attributes.color == undefined) {
          refMesh.current.material.vertexColors = false;
          refMesh.current.material.color = new THREE.Color(color);
        } else {
          refMesh.current.material.vertexColors = true;
          // deine which color to use
          refMesh.current.material.color = new THREE.Color('#FFFFFF');
        }
      } else if (process.env.REACT_APP_CALC_MODE == 1) {
        if (meshSocket.vertices && meshSocket.faces) {
          ref.current.setFromPoints(meshSocket.vertices);
          ref.current.setIndex(meshSocket.faces)
        }
      }
      //handleExport(meshSocket.geometry);
    }
  }, [meshSocket, clickable]);

  useEffect(() => {
    if (refMesh.current) {
      if (executeSmoothControl != executeSmooth) {
        if (iterationSmooth > 0) { // this is iteration count
          console.log("smooth");
          const outputGeom = laplacianSmooth(refMesh.current.geometry, iterationSmooth);
          refMesh.current.geometry = outputGeom;
        }
        setExecuteSmoothControl(executeSmooth);
      }
    }
  }, [executeSmooth]);

  return (
    <mesh ref={refMesh} key={0} rotation={rotation} onClick={onClick} receiveShadow castShadow renderOrder={5}>
      <bufferGeometry attach="geometry" ref={ref} />
      
      {/* <meshLambertMaterial attach='material' color={color} transparent={true} opacity={opacity} side={THREE.DoubleSide}/> */}
      {/* <meshNormalMaterial attach='material' color={color} transparent={true} opacity={opacity} side={THREE.DoubleSide} /> */}
      {/* <meshPhongMaterial attach='material' color={color} side={THREE.DoubleSide} transparent={true} opacity={opacity} castShadow receiveShadow/> */}
      <meshPhongMaterial attach='material' side={THREE.DoubleSide} vertexColors transparent={true} opacity={opacity} depthTest={true} depthWrite={true} />
    </mesh>
  )
});

export default MSocket
